export default "__VITE_ASSET__Ddd19$UZ__"